// controls/company.js — champ complexe "Entreprise"
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";

import { BiBuilding } from "react-icons/bi";
import { debug } from './../../../../utils'
/**
 * Création du champ complexe "company"
 */
export function createCompanyField() {
  return {
    type: "object",
    title: "Entreprise",
    "x-ui": "company",
    properties: {
      raisonSociale: { type: "string", title: "Raison sociale" },
      enseigne: { type: "string", title: "Enseigne" },
      adresse: {
        type: "object",
        title: "Adresse",
        properties: {
          rue: { type: "string", title: "Rue" },
          codePostal: { type: "string", title: "Code postal" },
          ville: { type: "string", title: "Ville" },
        },
      },
      siret: { type: "string", title: "SIRET" },
      tva: { type: "string", title: "N° TVA intracommunautaire" },
      formeJuridique: { type: "string", title: "Forme juridique" },
      capital: { type: "number", title: "Capital social" },
      telephone: { type: "string", title: "Téléphone" },
      email: { type: "string", title: "E-mail professionnel" },
      siteWeb: { type: "string", title: "Site web" },
    },
    "x-display": {
      enseigne: false,
      adresse: true,
      siret: true,
      tva: true,
      formeJuridique: false,
      capital: false,
      telephone: false,
      email: false,
      siteWeb: false,
    },
  };
}
/**
 * 🧩 Éditeur du champ "Entreprise"
 */
export function EditCompanyField({ field, onChange }) {
  const display = field["x-display"] || {};
  const [displayOptions, setDisplayOptions] = useState({
    raisonSociale: display.raisonSociale ?? true,
    enseigne: display.enseigne ?? true,
    adresse: display.adresse ?? true,
    siret: display.siret ?? true,
    tva: display.tva ?? true,
    formeJuridique: display.formeJuridique ?? false,
    capital: display.capital ?? false,
    telephone: display.telephone ?? false,
    email: display.email ?? false,
    siteWeb: display.siteWeb ?? false,
  });
  useEffect(() => {
    onChange({
      ...field,
      "x-display": displayOptions,
    });
  }, [displayOptions]);
  const toggleOption = (key) => {
    setDisplayOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  return (
    <>
      <CommonControls field={field} onChange={onChange} />
      <div className="mb-3">
        <label className="form-label fw-bold d-flex align-items-center gap-2">
          <BiBuilding size={18} /> Configuration du champ "Entreprise"
        </label>
        {[
          { key: "raisonSociale", label: "Afficher le champ Raison Sociale" },
          { key: "enseigne", label: "Afficher le champ Enseigne" },
          { key: "adresse", label: "Afficher le bloc Adresse (rue, code postal, ville)" },
          { key: "siret", label: "Afficher le champ SIRET" },
          { key: "tva", label: "Afficher le champ Numéro de TVA intracommunautaire" },
          { key: "formeJuridique", label: "Afficher le champ Forme juridique" },
          { key: "capital", label: "Afficher le champ Capital social" },
          { key: "telephone", label: "Afficher le champ Téléphone" },
          { key: "email", label: "Afficher le champ E-mail professionnel" },
          { key: "siteWeb", label: "Afficher le champ Site web" },
        ].map((opt) => (
          <div className="form-check" key={opt.key}>
            <input
              className="form-check-input"
              type="checkbox"
              id={`show_${opt.key}`}
              disabled={opt.key === 'raisonSociale'}
              checked={displayOptions[opt.key]}
              onChange={() => toggleOption(opt.key)}
            />
            <label className="form-check-label" htmlFor={`show_${opt.key}`}>
              {opt.label}
            </label>
          </div>
        ))}
      </div>
    </>
  );
}
/* =========================================================
   🧩 FRONT — rendu du champ "Entreprise"
   ========================================================= */
export const RenderCompanyField = ({
  field,
  value = {},
  onChange,
  className,
  errorMessage,     // <---- AJOUT ICI
  errors
}) => {
  const display = field["x-display"] || {};
  const required = field.required || false;
  const handleChange = (key, val) => {
    const updated = { ...value, [key]: val };
    onChange?.(updated);
  };
  const handleAdresseChange = (key, val) => {
    const updatedAdresse = { ...(value.adresse || {}), [key]: val };
    onChange?.({ ...value, adresse: updatedAdresse });
  };
  // class utilitaire à appliquer sur tous les champs s’il y a erreur
  const invalidClass = errorMessage ? "is-invalid" : "";
  return (
    <div
      className={`
        fb-field fb-company
        ${field["x-bloc-class"] || ""}
        ${className || ""}
      `}
    >

      {/* Titre */}
      {field.title && (
        <label className={`form-label fw-bold d-block mb-2}`}>
          {/*  ${errorMessage ? "text-danger" : "" */}
          {field.title} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <div className={`row g-2 ${field["x-control-class"] || ""}`}>
        {/* Raison sociale */}
        <div className="col-12">
          <label className="form-label">Raison sociale</label>
          <input
            type="text"
            className={`form-control form-control-sm ${errors?.raisonSociale ? "is-invalid" : ""}`}
            value={value.raisonSociale || ""}
            onChange={(e) => handleChange("raisonSociale", e.target.value)}
          />
        </div>
        {display.enseigne && (
          <div className="col-md-6">
            <label className="form-label">Enseigne</label>
            <input
              type="text"
              className={`form-control form-control-sm ${errors?.enseigne ? "is-invalid" : ""}`}
              value={value.enseigne || ""}
              onChange={(e) => handleChange("enseigne", e.target.value)}
            />
          </div>
        )}
        {display.formeJuridique && (
          <div className="col-md-6">
            <label className="form-label">Forme juridique</label>
            <input
              type="text"
              className={`form-control form-control-sm ${errors?.formeJuridique ? "is-invalid" : ""}`}
              value={value.formeJuridique || ""}
              onChange={(e) => handleChange("formeJuridique", e.target.value)}
            />
          </div>
        )}
        {display.adresse && (
          <>
            <div className="col-12 mt-3">
              <label className="form-label fw-semibold">Adresse</label>
            </div>
            <div className="col-12">
              <input
                type="text"
                className={`form-control form-control-sm ${errors?.adresse?.rue ? "is-invalid" : ""}`}
                placeholder="Rue"
                value={value.adresse?.rue || ""}
                onChange={(e) => handleAdresseChange("rue", e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <input
                type="text"
                className={`form-control form-control-sm ${errors?.adresse?.codePostal ? "is-invalid" : ""}`}

                placeholder="Code postal"
                value={value.adresse?.codePostal || ""}
                onChange={(e) => handleAdresseChange("codePostal", e.target.value)}
              />
            </div>
            <div className="col-md-8">
              <input
                type="text"
                className={`form-control form-control-sm ${errors?.adresse?.ville ? "is-invalid" : ""}`}
                placeholder="Ville"
                value={value.adresse?.ville || ""}
                onChange={(e) => handleAdresseChange("ville", e.target.value)}
              />
            </div>
          </>
        )}
        {display.siret && (
          <div className="col-md-6 mt-3">
            <label className="form-label">SIRET</label>
            <input
              type="text"
              className={`form-control form-control-sm ${errors?.siret ? "is-invalid" : ""}`}
              value={value.siret || ""}
              onChange={(e) => handleChange("siret", e.target.value)}
            />
          </div>
        )}
        {display.tva && (
          <div className="col-md-6 mt-3">
            <label className="form-label">N° TVA intracommunautaire</label>
            <input
              type="text"
              className={`form-control form-control-sm ${errors?.tva ? "is-invalid" : ""}`}
              value={value.tva || ""}
              onChange={(e) => handleChange("tva", e.target.value)}
            />
          </div>
        )}
        {display.capital && (
          <div className="col-md-6 mt-3">
            <label className="form-label">Capital social (€)</label>
            <input
              type="number"
              className={`form-control form-control-sm ${errors?.capital ? "is-invalid" : ""}`}
              value={value.capital || ""}
              onChange={(e) => handleChange("capital", e.target.value)}
            />
          </div>
        )}
        {display.telephone && (
          <div className="col-md-6 mt-3">
            <label className="form-label">Téléphone</label>
            <input
              type="tel"
              className={`form-control form-control-sm ${errors?.telephone ? "is-invalid" : ""}`}
              value={value.telephone || ""}
              onChange={(e) => handleChange("telephone", e.target.value)}
            />
          </div>
        )}
        {display.email && (
          <div className="col-md-6 mt-3">
            <label className="form-label">E-mail professionnel</label>
            <input
              type="email"
              className={`form-control form-control-sm ${errors?.email ? "is-invalid" : ""}`}
              value={value.email || ""}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </div>
        )}
        {display.siteWeb && (
          <div className="col-md-6 mt-3">
            <label className="form-label">Site web</label>
            <input
              type="url"
              className={`form-control form-control-sm ${errors?.siteWeb ? "is-invalid" : ""}`}
              placeholder="https://"
              value={value.siteWeb || ""}
              onChange={(e) => handleChange("siteWeb", e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
